import { render, staticRenderFns } from "./TheAlertModal.vue?vue&type=template&id=7dd16542"
import script from "./TheAlertModal.vue?vue&type=script&lang=js"
export * from "./TheAlertModal.vue?vue&type=script&lang=js"
import style0 from "./TheAlertModal.vue?vue&type=style&index=0&id=7dd16542&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports